import axios, {
  AxiosInstance,
  AxiosResponse,
  AxiosRequestConfig,
  AxiosError,
} from "axios";
import router from "@/router/index";

export class DataService {
  protected readonly instance: AxiosInstance;

  public constructor() {
    this.instance = axios.create({
      baseURL: process.env.VUE_APP_API_URL,
    });
    this._authInterceptor();
    this.instance.interceptors.request.use((request) =>
      this._handleRequest(request)
    );
  }

  private _successHandler = (response: AxiosResponse) => {
    return response;
  };

  private _errorHandler = (error: AxiosError) => {
    const status = error.response?.status;

    if (status === 401) {
      console.log("unauthorized");
      router.push("/");
    }

    if (status === 500) {

      console.log("Server Error");
      router.push("/");
    }

    if (status === 405) {
      console.log("Not Allowed");
    }

    return Promise.reject({ ...error });
  };

  private _authInterceptor = () => {
    this.instance.interceptors.response.use(
      (response) => this._successHandler(response),
      (error) => this._errorHandler(error),
    );
  };

  private _handleRequest = function (config: AxiosRequestConfig) {
    config.headers["Content-Type"] = "application/json";
    config.headers["Accept"] = "application/json";
    config.headers["Authorization"] = `Bearer ${localStorage.token}`;
    config.headers["Access-Control-Allow-Origin"] = "*";
    // console.log({ reqHandle: "Request Handler", config: config });

    return config;
  };
}
